module.exports = __webpack_public_path__ + "img/image2.20a6e3d5.png";